import Stats from 'stats.js';
export class StatsPanel {
    constructor() {
        this.stats = new Stats();
    }
    begin() {
        this.stats.begin();
    }
    end() {
        this.stats.end();
    }
    getParentElement() {
        return this.stats.dom.parentElement;
    }
    addPanel() {
        document.body.appendChild(this.stats.dom);
    }
    removePanel() {
        document.body.removeChild(this.stats.dom);
    }
    showPanel(panel) {
        this.stats.showPanel(panel); // 0: fps, 1: ms, 2: mb, 3+: custom
    }
}
//# sourceMappingURL=stats.js.map